import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const initialState = {
  duration: null,
  payout: null,
  start_time: null,
  end_time: null,
};

const ahworkSlice = createSlice({
  name: 'ahwork',
  initialState,
  reducers: {
    ahWorkShiftUpdated(state, action) {
      Object.assign(state, action.payload);
    },
    ahWorkShiftUpdateError(state) {
      // keep previous state on error
    },
  },
});

export const { ahWorkShiftUpdated, ahWorkShiftUpdateError } = ahworkSlice.actions;

export const requestAhWorkShift = () => dispatch => {
  const url = 'https://wonder.kevinvandertoorn.com/ah-work/api/shift/upcoming_shift/';

  const request = () => {
    axios
      .get(url)
      .then(({ data }) => {
        dispatch(ahWorkShiftUpdated(data));
      })
      .catch(() => {
        dispatch(ahWorkShiftUpdateError());
      });
  };

  request();
};

export default ahworkSlice.reducer;


